module.exports = __webpack_public_path__ + "img/person-circle.536f1b31.svg";